export function Footer() {
  return (
    <footer style={{ paddingTop: 44, display: "flex", flexDirection: "column", alignItems: "center", gap: 6, textAlign: "center" }}>
      <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 11, letterSpacing: "0.08em", color: "#5C5F5A" }}>dnsleak.rapidtunnel.com</div>
      <div style={{ fontSize: 12, color: "#5C5F5A" }}>
        Get your own private VPN tunnel at&nbsp;<a href="https://rapidtunnel.com">rapidtunnel.com</a> — no email required.
      </div>
    </footer>
  );
}
